var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransferIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M284.97,150c0-74.51-60.47-134.97-134.97-134.97S15.03,75.49,15.03,150S75.49,284.97,150,284.97S284.97,224.51,284.97,150z  M190.49,75.76l42.52,42.52c2.7,2.7,2.7,6.88,0,9.58l-42.52,42.38V136.5H136.5v-26.99h53.99V75.76z M109.51,224.24l-42.52-42.52 c-2.7-2.7-2.7-6.88,0-9.58l42.52-42.38v33.74h53.99v26.99h-53.99V224.24z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferIcon);
export default __webpack_public_path__ + "static/media/TransferIcon.3e9acc1fb5428915994ee4a097d5aefb.svg";
export { ForwardRef as ReactComponent };